import { LectureInfoList } from '#organisims/LectureInfoList';
import { LectureLocation } from '#organisims/LectureLocation';
import { LectureSchedule } from '#organisims/LectureSchedule';
import { Gym } from '#types/gyms';
import * as S from './styles';

interface LectureInfoProps {
  recommendGyms?: Gym[];
}

export const LectureInfoTab = ({ recommendGyms }: LectureInfoProps) => {
  return (
    <S.Container>
      <LectureInfoList />
      <LectureSchedule />
      <LectureLocation recommendGyms={recommendGyms} />
    </S.Container>
  );
};
